<template>
    <div>
                
        <vs-button color="primary" type="border" icon-pack="feather" icon="preview" class="mr-2" @click="hanldeViewSidebar"></vs-button>
         <add-call-history
   v-if="addcall"
    :isSidebarActive="addNewCallSidebar"
    :leadId="leadId"
    @closeSidebarCall="pushCall"
   />

    </div>
</template>
<script>
import { mapActions } from 'vuex'
import AddCall from './components/Sidebar/addCallHistory'
export default {
  components: {
    AddCall
  },
  name: 'AddCall',
  mounted () {
    this.action = this.params.data.actionData
  },
  data () {
    return {
      action:{},
      addNewCallSidebar:false
    }
  },
  methods: {
    ...mapActions(
      ['SET_DELETE_ID', 'SET_VIEW_LEADS_SIDEBAR', 'SET_VIEW_LEADS_SIDEBAR_DATA', 'SET_LEADS_TOGGLE_DATA']
    ),
    
    hanldeViewSidebar () {
      
      this.addNewCallSidebar = true
    }
  }
}
</script>
